import "./PatientBooking.module.css";
import Header from "@/reusable_sections/Header";
import RequestAFreeQuote from "./sections/RequestAFreeQuote";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function PatientBookingPage() {
  return <div>
      <Header />
      <RequestAFreeQuote />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}